module.exports = __webpack_public_path__ + "static/media/correo.c07dff9f.svg";